// XMLHttpRequest-based fetch to bypass platform's fetch() interception
// The Emergent platform injects emergent-main.js which patches window.fetch,
// causing "body stream already read" errors. This uses XHR to avoid that.

// Returns { ok, status, data } directly (for admin pages)
export const safeFetch = (url, options = {}) => {
  return new Promise((resolve) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      
      if (options.headers) {
        Object.entries(options.headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });
      }
      
      xhr.onload = function() {
        let data = null;
        try {
          data = JSON.parse(xhr.responseText);
        } catch (e) {
          data = { detail: 'Failed to parse response' };
        }
        resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, data });
      };
      
      xhr.onerror = function() {
        resolve({ ok: false, status: 0, data: { detail: 'Network error' } });
      };
      
      if (options.body) {
        xhr.send(options.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      resolve({ ok: false, status: 0, data: { detail: err.message } });
    }
  });
};

// Response-compatible safeFetch (for pages that use response.json() / response.text() patterns)
export const safeFetchCompat = (url, options = {}) => {
  return new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      
      if (options.headers) {
        Object.entries(options.headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });
      }
      
      xhr.onload = function() {
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          statusText: xhr.statusText,
          text: () => Promise.resolve(xhr.responseText),
          json: () => {
            try {
              return Promise.resolve(JSON.parse(xhr.responseText));
            } catch (e) {
              return Promise.reject(new Error('Invalid JSON'));
            }
          },
          headers: new Headers()
        });
      };
      
      xhr.onerror = function() {
        reject(new Error('Network error'));
      };
      
      if (options.body) {
        xhr.send(options.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      reject(err);
    }
  });
};
